module.exports = __webpack_public_path__ + "img/character-logistic-trash-slots.e3aa5446.png";